import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import Modal from 'shared/components/Modal';
import DestinationDetailViewer from 'shared/components/DestinationDetailViewer';
import { closeModal } from 'services/modal/actions';
import { getCreatedWorkflow } from 'services/workflow/getters';

import WorkflowCreatedModalFooter from './WorkflowCreatedModalFooter';

const MODAL_NAME = 'workflow-created-modal';

const StyledModal = styled(Modal)`
  width: 45rem;
`;

const StyledContainer = styled.div`
  margin-top: 1.333333333rem;
  padding: 0 1.333333333rem;
`;

const StyledInfoContainer = styled.div`
  margin-top: 1.916666667rem;
`;

const StyledDestinationDetailViewer = styled(DestinationDetailViewer)`
  width: 26.5rem;
  box-sizing: border-box;
`;

const StyledSubtitle = styled.h4`
  margin: 0;
  font-weight: 400;
`;

const WorkflowCreatedModal = () => {
  const dispatch = useDispatch();
  const createdWorkflow = useSelector(getCreatedWorkflow);

  const onClose = useCallback(() => {
    dispatch(closeModal(MODAL_NAME))
  }, []);

  if (!createdWorkflow) {
    return null;
  }

  return (
    <StyledModal
      isFullscreenMode={false}
      name={MODAL_NAME}
      title={`${createdWorkflow.name} created`}
      modalFooterComponent={WorkflowCreatedModalFooter}
      modalFooterComponentProps={{ onClose }}
    >
      <StyledContainer>
        <StyledSubtitle>Below are the destination credentials for your workflow.</StyledSubtitle>
        <StyledInfoContainer>
          {createdWorkflow.destination && (
            <StyledDestinationDetailViewer
              workflowGuid={createdWorkflow.guid!}
              destination={createdWorkflow.destination}
            />
          )}
        </StyledInfoContainer>
      </StyledContainer>
    </StyledModal>
  );
};

export { MODAL_NAME };
export default WorkflowCreatedModal;
